module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_16.5ad0de76.svg";